'use client';

import { Tabs as HeroTabs } from '@heroui/react';
import { ReactNode, Key } from 'react';

export interface TabItem {
  id: string;
  label: ReactNode;
  isDisabled?: boolean;
}

export interface TabsProps {
  items: TabItem[];
  selectedKey?: string;
  defaultSelectedKey?: string;
  onSelectionChange?: (key: Key) => void;
  variant?: 'primary' | 'secondary';
  ariaLabel?: string;
}

export const Tabs = ({
  items,
  selectedKey,
  defaultSelectedKey,
  onSelectionChange,
  variant = 'primary',
  ariaLabel,
}: TabsProps) => {
  return (
    <HeroTabs
      selectedKey={selectedKey}
      defaultSelectedKey={defaultSelectedKey}
      onSelectionChange={onSelectionChange}
      variant={variant}
    >
      <HeroTabs.ListContainer>
        <HeroTabs.List className="text-nowrap" aria-label={ariaLabel}>
          {items.map((item) => (
            <HeroTabs.Tab
              key={item.id}
              id={item.id}
              isDisabled={item.isDisabled}
            >
              {item.label}
              <HeroTabs.Indicator />
            </HeroTabs.Tab>
          ))}
        </HeroTabs.List>
      </HeroTabs.ListContainer>
    </HeroTabs>
  );
};
